import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Button from '../elements-buttons/Button';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { getCloudinaryTextData } from 'shared-components/inputs/data/cloudinary-data';

class AddOnPhoto extends Component {
  constructor (props) {
    super(props);
    const locale = props.intl.locale;
    this.state = {
      addOnPhotoPresets: {
        upload_preset: 'zsxtv3jx',
        show_powered_by: false,
        multiple: false,
        aspect_ratio: '4:3',
        cropping: 'server',
        cropping_aspect_ratio: 1.333,
        client_allowed_formats: ['jpg', 'jpeg', 'png'],
        sources: ['local'],
        theme: 'white',
        max_file_size: 4000000,
        max_image_width: 1000,
        max_image_height: 1000,
        showSkipCropButton: false,
        language: locale,
        text: {
          [locale]: getCloudinaryTextData(this.props.intl)
        }
      },
      widget: null,
      imgUrl: '',
      imgId: ''
    };

    this.onTransactableAddOnPhotoUpload = this.onTransactableAddOnPhotoUpload.bind(this);
    this.renderCloudinaryWidget = this.renderCloudinaryWidget.bind(this);
    this.onRemovePhotoClick = this.onRemovePhotoClick.bind(this);
  }

  componentDidMount () {
    cloudinary.setCloudName('peerspace-inc');

    const widget = cloudinary.createUploadWidget(this.state.addOnPhotoPresets, function (error, result) {
      this.onTransactableAddOnPhotoUpload(error, result);
    }.bind(this));

    this.setState({
      widget: widget
    });
  }

  onTransactableAddOnPhotoUpload (error, result) {
    if (error) {
      this.setState({
        photoError: this.props.intl.formatMessage({ id: 'inbox.add_on_photo.something_wrong', defaultMessage: 'Something went wrong.  Please try again.' })
      });
    } else if ('success' === result.event) {
      const imgInfo = (result || {}).info || {};
      const newImgURL = imgInfo.secure_url;
      const publicId = get(result, 'info.public_id', '');

      this.setState({
        imgUrl: newImgURL
      });

      this.props.handlePhotoChange(newImgURL, publicId);
    }
  }

  renderCloudinaryWidget (e) {
    e.preventDefault();
    this.state.widget.open();
  }

  onRemovePhotoClick (e) {
    e.preventDefault();

    this.props.handleRemovePhotoClick();
  }

  render () {
    const { addOnImgId } = this.props;
    const imgUrl = addOnImgId.length
      ? `https://img.peerspace.com/image/upload/${addOnImgId}.jpg`
      : '';

    const displayAddPhoto = !imgUrl.length;

    return (
      <div className="AddOnPhoto margin-xl-bottom">
        <div className="add-photo-section">
          <label className="label" htmlFor="photo">
            <FormattedMessage
              id='inbox.add_on_photo.photo'
              defaultMessage='Photo'
            />
          </label>

          <div className="add-photo-box-wrapper">
            <div className="add-photo-box bg-gray-200 flex center middle">
              {
                displayAddPhoto ?
                  <div>
                    <Button
                      category="secondary"
                      onClick={this.renderCloudinaryWidget}
                      type="button"
                      attributes={{ 'data-testing-id': 'add-photo-btn' }}
                    >
                      <FormattedMessage
                        id='inbox.add_on_photo.add_photo'
                        defaultMessage='+ Add Photo'
                      />
                    </Button>
                  </div>
                  :
                  <img
                    className="add-on-photo full-height full-width"
                    src={imgUrl}
                    alt={ this.props.intl.formatMessage({ id: 'inbox.add_on_photo.addon_alt', defaultMessage: 'Add-on image' }) }
                  />
              }
            </div>
          </div>

          {
            !displayAddPhoto &&
              <div>
                <Button
                  type="button"
                  className="btn-default col-xs-12 margin-md-bottom margin-md-top"
                  attributes={{ 'data-testing-id': 'update-photo-btn' }}
                  onClick={this.renderCloudinaryWidget}
                >
                  <FormattedMessage
                    id='inbox.add_on_photo.update_photo'
                    defaultMessage='Update Photo'
                  />
                </Button>

                <Button
                  type="button"
                  className="btn-default col-xs-12 margin-xl-bottom"
                  attributes={{ 'data-testing-id': 'remove-photo-btn' }}
                  onClick={this.onRemovePhotoClick}
                >
                  <span className="text-red">
                    <FormattedMessage
                      id='inbox.add_on_photo.remove_photo'
                      defaultMessage='Remove Photo'
                    />
                  </span>
                </Button>
              </div>
          }
        </div>
      </div>
    );
  }
}

AddOnPhoto.propTypes = {
  handlePhotoChange: PropTypes.func,
  addOnImgId: PropTypes.string,
  isEditAddOnModal: PropTypes.bool,
  handleRemovePhotoClick: PropTypes.func,
  intl: intlShape
};

export default injectIntl(AddOnPhoto);
